var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "w-ext-login-body" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn-block btn-iot btn-login",
          attrs: { disabled: _vm.disableLogin, href: _vm.externalLoginUrl },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("login.sso_external_credientials")) +
              "\n      "
          ),
          _c("i", {
            staticClass: "fas fa-spinner fa-spin spin-off",
            class: { active: _vm.spinOff },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm._m(2),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-ext-login-header" }, [
      _c("img", {
        staticClass: "w-logo",
        attrs: {
          rel: "preload",
          src: require("@/assets/images/logo_scmgroup.svg"),
          alt: "Scm Group",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "oval" }, [
      _c("img", {
        attrs: {
          rel: "preload",
          src: require("@/assets/images/user.png"),
          alt: "User",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-ext-login-footer" }, [
      _c("img", {
        attrs: {
          rel: "preload",
          src: require("@/assets/images/home-ind-scm.svg"),
          alt: "Scm",
        },
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          rel: "preload",
          src: require("@/assets/images/home-ind-cms.svg"),
          alt: "Cms",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }